// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const CUENTAS_PAGAR = {
  mensaje: '¿Qué necesitas en Cuentas por Pagar?',
  opciones: [
    {
      boton: 'Registrar un pago',
      respuesta: 'Ve a C. por Pagar → Pagos. Selecciona el proveedor y los documentos que deseas cancelar.',
    },
    {
      boton: 'Obligaciones pendientes',
      respuesta: 'Consulta lo que se debe en C. por Pagar → Consultas → Estado de cuenta proveedor.',
    },
  ],
}
